export const BOOKING_PAGE_TITLE = 'Book Appointment';

export const pastAppointmentsSortOptions = [
  { label: 'Oldest', value: 'asc' },
  { label: 'Newest', value: 'desc' }
];

export const redirectExternalSchedulingUrl = 'https://intermountainhealthcare.org/find-a-doctor/';
